import i18nFactory from '@yandex-int/i18n';
import { ButtonPin } from 'lego-on-react';

import { FiltersValue, OutdoorDictionary } from '../../../typings/displayMap';
import {
    filterType,
    selectedFilters as easySelectedFilters
} from '../../EasyFilters/EasyFilters';

import * as keyset from './Outdoor.i18n';

const i18n = i18nFactory(keyset);

export const OutdoorUtils = {
    getFilters: (
        filtersValue: FiltersValue,
        selectedFilters: {
            [name: string]: easySelectedFilters;
        },
        dictionary: OutdoorDictionary
    ) => {
        // TODO отделить changed от значения фильтров
        // TODO тайп для selectedFilters
        // TODO «Очистить»
        return [
            {
                name: 'operatorName',
                type: filterType.multiSelect,
                selected: selectedFilters.operatorName || [],
                items: filtersValue.operatorName.map((item: string) => ({
                    text: item,
                    val: item
                })),
                text: i18n('operatorName'),
                button: {
                    pin: 'circle-circle' as ButtonPin
                },
                optionalPlaceHolder: true
            },
            {
                name: 'facilityType',
                type: filterType.multiSelect,
                selected: selectedFilters.facilityType || [],
                items: filtersValue.facilityType.map((item: string) => ({
                    text: dictionary.facility[item],
                    val: item
                })),
                text: i18n('format'),
                button: {
                    pin: 'circle-circle' as ButtonPin
                },
                optionalPlaceHolder: true
            },
            {
                name: 'selected',
                type: filterType.boolean,
                selected: !!selectedFilters.selected,
                pin: 'circle-circle' as ButtonPin,
                text: i18n('selected')
            }
        ];
    }
};
